import { Routes } from '@/routes';

export default {
	'document.index': () => import('@/modules/documents/index'),
} as Routes;
